import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
//STYLES
import '../CSS/style_Login.css';
import '../CSS/App.css';

//COMPONENTS
import LoginForm        from "../Components/component_LoginForm";
import Loader           from "../Components/component_Loader";
import ImgLogo          from "../Images/logo-bilanciai.png";
import ImgLogoIS        from "../Resources/logo.png";
import { login }        from '../Actions/Action_Authentication';
import WorkInProgress   from "../Images/work-in-progress.png";
//Utils
import * as ROLES from "../Utils/Roles_Types.js";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import { getUserInfo } from "../Actions/Action_Authentication";
import { checkUserLanguage } from "../Utils/Check_Value.js";

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

class LoginContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    let token = localStorage.getItem(ROLES.TOKEN_KEY) || null;
    if(token != null) this.props.dispatch(getUserInfo());
  }

  render() {
    if(this.props.isAuthenticated)
      PAGESSWITCH.gotoPageWithParams("/home");
    return (
      <div className="login-page">
        <div className="first">
            
        </div>
        <Loader isFetching={this.props.isFetching}/>
          <LoginForm 
            dispatch      = {this.props.dispatch}
            error         = {this.props.errorMessage}
            usernameError = {this.props.usernameError}
            passwordError = {this.props.passwordError}/>
          <div className="footer clearfix">
            <div className="left"><img src={ImgLogo} /></div>
            <div className="right"><div><img src={ImgLogoIS} /></div></div>
          </div>
      </div>);
  }
}

LoginContainer.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  const { authenticationReducer } = state;
  const { isFetching, errorMessage, isAuthenticated, usernameError, passwordError } = authenticationReducer;
	return { 
    isFetching,
    errorMessage,
    usernameError,
    passwordError,
    isAuthenticated
  };
}

export default connect(mapStateToProps)(LoginContainer);


// WEBPACK FOOTER //
// ./src/Containers/Login.js